import React, { useState, useEffect, useCallback } from "react";
import cogoToast from "cogo-toast";
import "../app/user-pages/userpages.css";
import { Table } from "react-bootstrap";
import "../app/user-pages/table.css";
export const formatStanderdTimeString = (inputTime) => {
  const inputDate = new Date(inputTime);

  // Check if inputDate is a valid date
  if (!isNaN(inputDate.getTime())) {
    const year = inputDate.getFullYear();
    const month = (inputDate.getMonth() + 1).toString().padStart(2, "0");
    const day = inputDate.getDate().toString().padStart(2, "0");
    const hours = inputDate.getHours().toString().padStart(2, "0");
    const minutes = inputDate.getMinutes().toString().padStart(2, "0");
    const seconds = inputDate.getSeconds().toString().padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  } else {
    // If inputTime is not a valid date, return it as is (assumed to be in "hh:mm:ss" format)
    return inputTime;
  }
};

export const getDateBefore30Days = () => {
  const today = new Date();
  today.setDate(today.getDate() - 30); // Subtract 30 days from the current date
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export function formatDateTime(dateTimeString) {
  if (!dateTimeString) {
    return "";
  }
  const date = new Date(dateTimeString);

  // Format date as "dd-MMM-yyyy" in UTC
  const day = date.getUTCDate().toString().padStart(2, "0");
  const month = date.toLocaleString("en-US", {
    month: "short",
    timeZone: "UTC",
  });
  const year = date.getUTCFullYear();

  const formattedDate = `${day}-${month}-${year}`;

  // Format time as "h:mm:ss AM/PM" in UTC
  let hours = date.getUTCHours();
  const minutes = date.getUTCMinutes().toString().padStart(2, "0");
  const seconds = date.getUTCSeconds().toString().padStart(2, "0");
  const amPm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;

  const formattedTime = `${hours}:${minutes}:${seconds} ${amPm}`;

  // Combine date and time
  return `${formattedDate}, ${formattedTime}`;
}
export function getYMDHMSFormat(dateTimeString) {
  if (!dateTimeString) {
    return "";
  }

  const date = new Date(dateTimeString);

  // Format date as "yyyy-mm-dd" using local time
  const year = date.getFullYear(); // Use local time
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-indexed
  const day = date.getDate().toString().padStart(2, "0"); // Use local day

  const formattedDate = `${year}${month}${day}`;

  // Format time as "hh:mm:ss" in local time (24-hour format)
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const seconds = date.getSeconds().toString().padStart(2, "0");

  const formattedTime = `${hours}${minutes}${seconds}`;

  // Combine date and time with an underscore separator
  return `${formattedDate}_${formattedTime}`;
}

export function formatDate(dateTimeString) {
  if (!dateTimeString) {
    return "-";
  }
  const date = new Date(dateTimeString);

  // Format date as "dd-MMM-yyyy" in UTC
  const day = date.getUTCDate().toString().padStart(2, "0");
  const month = date.toLocaleString("en-US", {
    month: "short",
    timeZone: "UTC",
  });
  const year = date.getUTCFullYear();

  const formattedDate = `${day}-${month}-${year}`;

  // Combine date and time
  return `${formattedDate}`;
}
// Function to convert date format from "YYYY-MM-DD" to "DD MMM"
export function convertToDayMonth(dateString) {
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.toLocaleString("default", { month: "short" });
  return `${day} ${month}`;
}
export const MetricCard = ({ label, value, isFirst, totalValues }) => {
  // Dynamically calculate the column width based on the total number of values
  const columnClass =
    totalValues === 6
      ? "col-lg-2 col-md-4 col-sm-6" // Large screens: 2 columns, Medium: 4 columns, Small: 6 columns
      : totalValues === 4
        ? "col-lg-3 col-md-6 col-sm-6" // Large screens: 3 columns, Medium/Small: 6 columns
        : totalValues === 2
          ? "col-lg-6 col-md-12" // Large screens: 6 columns (half), Medium/Small: full width
          : "col-lg-12 col-md-12"; // Full width for 1 value or unknown count

  return (
    <div
      className={`${columnClass} ${isFirst ? "" : "border-md-start" // Only show the border on medium and larger screens
        } d-flex pt-3 pt-lg-0 align-items-center`}
    >
      <div className="flex-grow-1">
        <p className="mb-2 ml-1">{label}</p>
        <h3
          className="mb-0 ml-1 text-truncate"
          style={{ maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
        >
          {value}
        </h3>
      </div>
    </div>
  );
};
export const getCurrentDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

// Timer countdown function
export const useCountdownTimer = (initialTime, onExpire) => {
  const [timeLeft, setTimeLeft] = useState(initialTime);

  // Reset function that resets the timeLeft to the initialTime
  const resetTimer = useCallback(() => {
    setTimeLeft(initialTime);
  }, [initialTime]);

  useEffect(() => {
    if (timeLeft <= 0) {
      onExpire(); // Trigger callback when the timer expires
      return;
    }

    // Set up the interval to decrement time every second
    const timerId = setInterval(() => {
      setTimeLeft((prevTime) => prevTime - 1);
    }, 1000);

    // Clean up the interval on component unmount or when timer ends
    return () => clearInterval(timerId);
  }, [timeLeft, onExpire]);

  // Convert timeLeft into minutes and seconds for display
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;

  return { minutes, seconds, resetTimer, timeLeft };
};

//Copy To clipboard function
export const copyToClipboard = (text) => {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    // Use the modern Clipboard API if available
    navigator.clipboard
      .writeText(text)
      .then(() => {
        cogoToast.success("Copied successfully!", {
          hideAfter: 3,
        });
      })
      .catch((err) => {
        console.log("Failed to copy text with Clipboard API:", err);
      });
  } else {
    // Fallback for older browsers
    try {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.style.position = "fixed"; // Avoid scrolling to the bottom
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);

      cogoToast.success("Text Copied", {
        hideAfter: 3,
      });
    } catch (err) {
      console.error("Fallback: Unable to copy text", err);
    }
  }
};
// Function to check if criteria is met or pending
export const getStatusBadge = (criteriaValue, fulfilledValue) => {
  const criteria = parseFloat(criteriaValue || 0);
  const fulfilled = parseFloat(fulfilledValue || 0);

  return fulfilled >= criteria ? (
    <span className="badge bg-success text-white">Achieved</span>
  ) : (
    <span className="badge bg-warning text-white">{criteria - fulfilled}</span>
  );
};
// Function to check if criteria is met or pending for Archivment Rewards
export const getRewardBadge = (nextClubRank, currentClubRank) => {
  return nextClubRank === currentClubRank ? (
    <span className="badge bg-success text-white">Achieved</span>
  ) : (
    <span className="badge bg-warning text-white">Pending</span>
  );
};


// Helper function to determine status color
export const getStatusColor = (value, total) => {
  // Convert value and total to numbers, handle both integers and decimals
  const flatValue = parseFloat(value);
  const flatTotal = parseFloat(total);

  // Check if total is null
  if (total === null || total === undefined) {
    return { color: "text-black", statusText: "" }; // Default to black if total is null or undefined
  }

  // Compare the numeric values
  if (flatValue >= flatTotal) {
    return { color: "text-success", statusText: "Achieved" }; // Success if value >= total
  } else {
    return { color: "text-warning", statusText: "Pending" }; // Warning if value < total
  }
};
export function imageExists(url) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(true); // Image found
    img.onerror = () => resolve(false); // Image not found
    img.src = url;
  });
}

export const truncateText = (text, length = 5) => `${text.slice(0, length)}...`;

export const formatAmount = (amount, decimals) => {
  if (amount === null || amount === undefined || amount === "") return "";

  const parsedAmount = parseFloat(amount);

  // Function to round to specified decimals
  const roundToDecimals = (num, decimals) => {
    const factor = Math.pow(10, decimals);
    return Math.round(num * factor) / factor;
  };

  // Handle billions
  if (parsedAmount >= 1_000_000_000) {
    const result = roundToDecimals(parsedAmount / 1_000_000_000, decimals);
    // Ensure formatting respects decimals
    return result % 1 === 0
      ? `${result.toFixed(0)}B` // Integer display
      : `${result.toFixed(decimals)}B`; // Decimal display
  }

  // Handle millions
  if (parsedAmount >= 1_000_000) {
    const result = roundToDecimals(parsedAmount / 1_000_000, decimals);
    return result % 1 === 0
      ? `${result.toFixed(0)}M` // Integer display
      : `${result.toFixed(decimals)}M`; // Decimal display
  }

  // Handle integers
  if (parsedAmount % 1 === 0) {
    return parsedAmount.toString(); // Return as string for consistent output
  }

  // Handle smaller decimal numbers
  return roundToDecimals(parsedAmount, decimals)
    .toFixed(decimals)
    .replace(/\.?0+$/, ""); // Format to specified decimal places and remove trailing zeros
};

export function getRemainingTime(targetDateString) {
  // Convert the target date string into a Date object
  const targetDate = new Date(targetDateString);

  // Check if the target date is valid
  if (isNaN(targetDate.getTime())) {
    throw new Error("Invalid targetDate. Provide a valid date string.");
  }

  // Get the current date and time
  const currentTime = new Date();
  const difference = targetDate - currentTime; // Time difference in milliseconds

  // If the target date is in the past
  if (difference <= 0) {
    return "Your Subscription Expired";
  }

  // Helper function to check if the year is a leap year
  const isLeapYear = (year) => {
    return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
  };

  // Get the current year and month
  const currentYear = currentTime.getFullYear();
  const currentMonth = currentTime.getMonth(); // 0-based (0 = January, 1 = February, etc.)

  // Get the target year and month
  const targetYear = targetDate.getFullYear();
  const targetMonth = targetDate.getMonth();

  // Calculate the number of years
  let years = targetYear - currentYear;

  // Calculate the number of months
  let months = targetMonth - currentMonth;

  if (months < 0) {
    months += 12;
    years -= 1;
  }

  // Calculate the number of days
  let days = targetDate.getDate() - currentTime.getDate();
  if (days < 0) {
    // If the day is negative, adjust the month and calculate days from the previous month
    const previousMonth = new Date(targetDate.getFullYear(), targetDate.getMonth(), 0);
    days += previousMonth.getDate();
    months -= 1;
  }

  // Check if the current month is February and adjust for leap years
  let daysInFebruary = 28;
  if (currentMonth === 1) { // February (1)
    daysInFebruary = isLeapYear(currentYear) ? 29 : 28;
  }

  // Calculate the remaining time in hours, minutes, and seconds
  const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((difference % (1000 * 60)) / 1000);

  // Return the formatted time string
  return `${years}y ${months}mo ${days}d ${hours}h ${minutes}m ${seconds}s`;
}

// Function to start the countdown
export function startCountdown(targetDateString, callback) {
  const countdownInterval = setInterval(() => {
    const remainingTime = getRemainingTime(targetDateString);

    // Call the callback function to update the UI or log the result
    callback(remainingTime);

    // If the countdown reaches zero, stop the interval
    if (
      remainingTime.days === 0 &&
      remainingTime.hours === 0 &&
      remainingTime.minutes === 0 &&
      remainingTime.seconds === 0
    ) {
      clearInterval(countdownInterval);
      callback(remainingTime); // Ensure final state is displayed
    }
  }, 1000); // Update every second
}

export const TableComponent = ({ headers, rows }) => {
  return (
    <Table responsive bordered hover className="w-100">
      <thead>
        <tr>
          <th>Field</th> {/* The header for the first column */}
          {headers?.map((header, index) => (
            <th key={index}>{header}</th>
          ))}
        </tr>
      </thead>

      <tbody>
        {rows?.length > 0 ? (
          rows.map((row, rowIndex) => (
            <tr key={rowIndex}>
              <td>{row[0]}</td> {/* Display the first column as header */}
              {row.slice(1).map((cell, cellIndex) => (
                <td key={cellIndex}>{cell}</td>
              ))}
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={headers.length + 1} className="text-center">
              There is no record to display
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  );
};

export function calculateSelectedCurrencyAmount(resAmount , fees) {
  if (typeof resAmount !== "number" || isNaN(resAmount)) {
    throw new Error("Invalid input: resAmount must be a number.");
  }
  const numericFees = typeof fees === "string" ? parseFloat(fees) : fees;
  const selectedCurrencyAmount = resAmount + ((resAmount * numericFees) / 100);
  return selectedCurrencyAmount;
}
